export default () => {
	const dropDownToggle = document.querySelectorAll('.dropdown-toggle'),
		mobile = window.matchMedia("(min-width: 992px)");

	if(!dropDownToggle) return;

	dropDownToggle.forEach(item => {
		item.addEventListener('click', function () {
			if (mobile.matches) {
				const linkUrl = this.getAttribute('href');

				if (linkUrl !== '#') {
					window.location.href = linkUrl;
				}
			}
		})
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/menu-item.js